package com.xtream.ui.ui.widget

 import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusDirection
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.xtream.ui.ui.util.extensions.lightenColor

@Composable
expect fun ConfigureDialogWindowProperties()

@Composable
fun SharedDialogContainer(content: @Composable () -> Unit) {
    CompositionLocalProvider(LocalLayoutDirection provides LayoutDirection.Ltr) {
        // Trigger the window styling configurations safely per target platform
        ConfigureDialogWindowProperties()

        content()
    }
}
@Composable
fun LoadingDialog(show: Boolean=false){

    if (show) {
        Dialog (
            onDismissRequest = {  },
            DialogProperties(dismissOnBackPress = false, dismissOnClickOutside = false)
        ) {
            Box(
                contentAlignment= Alignment.Center,
                modifier = Modifier
                    .size(100.dp)
                    .clip(RoundedCornerShape(8.dp))
                    .background(MaterialTheme.colorScheme.secondaryContainer)
            ) {
                CircularProgressIndicator()
            }
        }
    }
}



@Composable
fun SideDialog(
    show: Boolean = false,
    title: String? = null,
    onDismiss: () -> Unit = {},
    contentAlignment: Alignment =Alignment.CenterEnd,
    content: @Composable () -> Unit = { }
) {
    if (show) {
        Dialog(
            onDismissRequest = onDismiss,
            properties = DialogProperties(
                usePlatformDefaultWidth = false
            )
        ) {
           /* CompositionLocalProvider {
                with((LocalView.current.parent as DialogWindowProvider).window){
                    setDimAmount(0f)
                    clearFlags(WindowManager.LayoutParams.FLAG_DIM_BEHIND)
                }*/

                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                           /*TODO .ifElse(

                                !isDpadNavigation(), Modifier
                                .focusable(false)
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null, // Removes the ripple effect
                                    onClick = { onDismiss() }
                                ))*/

                        ,
                        contentAlignment = contentAlignment
                    ) {
                        Surface(
                            shape = MaterialTheme.shapes.medium,
                            color = MaterialTheme.colorScheme.background,
                            modifier = Modifier
                                .padding(8.dp)
                                .width(320.dp)

                                .fillMaxHeight()
                            ,
                            tonalElevation = 0.dp, // Change this to 0dp
                            shadowElevation = 8.dp  // Keep this for the physical shadow
                        ) {
                            Column {
                                if(title!=null) {
                                    @OptIn(ExperimentalMaterial3Api::class)
                                    TopAppBar(
                                        colors = TopAppBarDefaults.topAppBarColors(
                                            containerColor = MaterialTheme.colorScheme.background,
                                            titleContentColor = MaterialTheme.colorScheme.onBackground,

                                            ),
                                        title = {
                                            Text(
                                                text = title ?: "",
                                                fontWeight = FontWeight.Bold,
                                                style = MaterialTheme.typography.titleLarge
                                            )
                                        },
                                    )
                                }
                                content()
                            }}
                    //}
                }
            }

    }
}





@Preview(showBackground = true)
@Composable
fun TestMessageDialog(){
    MaterialTheme(
        //colorScheme = DarkColorScheme,

        ){ XtreamBaseDialogCompose("Test Dialog", content = { Text("Do you want to Exit?") }) }
}

@Preview(showBackground = true, heightDp = 400)
@Composable
fun TestAlertDialogTest() {
    MaterialTheme(
       /// colorScheme = DarkColorScheme,

        ) {
        XtreamActionDialog(
            titleText = "Logout",
            positiveButtonText = "Yes",
            negativeButtonText = "No"){
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
            Text("Do you want to Exit?")
        }
    }
}


@Preview(showBackground = true, heightDp = 400)
@Composable
fun TestAlertDialogTest1() {
    MaterialTheme(
       // colorScheme = DarkColorScheme,

        ) {
        XtreamActionDialog(
            titleText = "Logout",
            positiveButtonText = "Yes",
            negativeButtonText = "No"){
            Text("Do you want to Exit?")

        }
    }
}





@Composable
fun XtreamActionDialog(titleText: String,
                       positiveButtonText: String="",
                       negativeButtonText: String="",
                       showPositiveButton:Boolean=true,
                       showNegativeButton:Boolean=true,
                       properties:DialogProperties = DialogProperties(

                           usePlatformDefaultWidth = true
                       ),
                       onPositiveButtonClick:()->Unit={},
                       onNegativeButtonClick:()->Unit={},
                       onDismiss:()->Unit={},

                       content: @Composable() (ColumnScope.() -> Unit)
) {

    val focusManager = LocalFocusManager.current
    BasicXtreamDialog(
        titleText,
        modifier = Modifier
            .fillMaxWidth()
            //.padding(.dp)
            .wrapContentHeight()
            . onKeyEvent { keyEvent ->
            if (keyEvent.type == KeyEventType.KeyDown) {
                when (keyEvent.key) {
                    Key.DirectionUp -> { focusManager.moveFocus(FocusDirection.Up); true }
                    Key.DirectionDown -> { focusManager.moveFocus(FocusDirection.Down); true }
                    Key.DirectionLeft -> { focusManager.moveFocus(FocusDirection.Left); true }
                    Key.DirectionRight -> { focusManager.moveFocus(FocusDirection.Right); true }
                    else -> false
                }
            } else {
                false
            }
        }

        ,
        properties= properties,
        onDismiss=onDismiss,
        content = {

            Column(
                modifier = Modifier
                    .wrapContentHeight()
                    .weight(1f, fill = false)



            ) { content.invoke(this) }

            Spacer(modifier = Modifier.height(16.dp))

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .wrapContentHeight()

                    .padding(horizontal = 8.dp),
                horizontalArrangement = Arrangement.End
            ) {
                if (showPositiveButton) {
                    XtreamComposeButton(positiveButtonText) {
                        onPositiveButtonClick.invoke()
                    }
                }
                if (showNegativeButton) {
                    Spacer(modifier = Modifier.width(8.dp))
                    XtreamComposeButton(negativeButtonText) {
                        onNegativeButtonClick.invoke()
                    }
                }

            }
        }
    )

}

@Composable
fun BasicXtreamDialog(titleText:String,

                      modifier: Modifier=Modifier,
                      properties:DialogProperties = DialogProperties(

                          usePlatformDefaultWidth = true
                      ),
                      onDismiss:()->Unit={},

                      content: @Composable() (ColumnScope.() -> Unit)
){
    Dialog(onDismissRequest = onDismiss,
        properties = properties
    ) {
        Surface (modifier = Modifier
            .focusProperties { canFocus = false }

            .clickable (
                enabled = true, // Keep it clickable, but...
                indication = null, // Removes the ripple effect
                interactionSource = remember { MutableInteractionSource() },
                onClick = onDismiss)

            .fillMaxSize()
            .wrapContentHeight(),



            ) {
            XtreamBaseDialogCompose(titleText, modifier, content)
        }
    }
}

@Composable
private fun XtreamBaseDialogCompose(titleText:String,

                                    modifier: Modifier=Modifier,

                                    content: @Composable() (ColumnScope.() -> Unit)
){

    Surface(
        modifier = modifier
            .focusProperties { canFocus = false }

            .clickable (
                enabled = true, // Keep it clickable, but...
                indication = null, // Removes the ripple effect
                interactionSource = remember { MutableInteractionSource() }, // Prevents interactions like focus or press

                onClick = {}),
        color = MaterialTheme.colorScheme.background.lightenColor(.01f),

        shape = RoundedCornerShape(16.dp)
    ) {

        Column(
            modifier = Modifier

                .fillMaxWidth()
                .padding(24.dp)
        ) {
            Text(
                text = titleText,
                modifier = Modifier.fillMaxWidth(),
                textAlign = TextAlign.Center,
                fontWeight = FontWeight.Bold,
                style = MaterialTheme.typography.titleLarge
            )
            Spacer(modifier = Modifier.height(16.dp))
            content.invoke(this)
        }

    }
// Ensure the focus request is triggered after composition

}
